import { faCheck, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Card } from 'src/components/Card';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { Typography } from 'src/components/Typography';
import {
  CartItem as CartItemType,
  PaymentOption,
} from 'src/models/cart/_types';
import { getPaymentOptionDetails } from 'src/models/cart/utils';
import { selectableItemTypes } from 'src/shared/constants/itemTypes';
import { Identifier } from 'src/types/utilityTypes';

import { CartItemAvatar } from '../../pages/Clients/PaymentDialog/CartItemAvatar';


interface SearchItem extends CartItemType {
  id: Identifier;
  name: string;
  aliases?: string[];
  header?: string;
  type: string;
  description?: string;
  paymentOptions?: PaymentOption[];
}

interface ItemCardProps {
  item: SearchItem;
  itemAdded: boolean;
  showTypeLabel?: boolean;
  onAdd: (item: SearchItem) => void;
  onRemove: (item: CartItemType) => void;
}

export const ItemCard = ({
  item,
  showTypeLabel = true,
  itemAdded,
  onAdd,
  onRemove,
}: ItemCardProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'client.payment' });

  const type = selectableItemTypes.find((t) => t.value === item.type);
  const typeLabel = type?.label;

  if (!item.name) return null;

  return (
    <Card
      key={`${item.id}-${item.type}`}
      variant="outlined"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        borderRadius: 1,
        border: 'none',
      }}
    >
      <CartItemAvatar item={item} />
      <Box sx={{ width: '100%' }}>
        <Typography
          variant="body1"
          dangerouslySetInnerHTML={{ __html: item.name }}
        />
        <Typography variant="body1" color="text.secondary">
          {!!item.paymentOptions &&
            item.paymentOptions?.length <= 1 &&
            !item.description && (
              <>
                {getPaymentOptionDetails(
                  item.paymentOption || item.paymentOptions[0]
                )}
              </>
            )}
          {!!item.paymentOptions && item.paymentOptions?.length > 1 && (
            <>{t('multipleOptions')}</>
          )}
          {(!item.paymentOptions || item.paymentOptions.length === 0) &&
            item.description && <>{item.description}</>}
        </Typography>

        {showTypeLabel && (
          <Typography
            variant="caption"
            color="textSecondary"
            sx={{ color: 'secondary.400' }}
          >
            {typeLabel}
          </Typography>
        )}
      </Box>
      <Box sx={{ justifySelf: 'flex-end' }}>
        <IconButton
          color="primary"
          sx={{ zIndex: '1' }}
          onClick={() => (itemAdded ? onRemove(item) : onAdd(item))}
        >
          <Icon
            icon={
              itemAdded
                ? faCheck
                : faPlus
            }
          />
        </IconButton>
      </Box>
    </Card>
  );
};
